import {
  DELETE_MEDIA_GALLERY_ITEM,
  DELETE_MEDIA_GALLERY_ITEM_FAILED,
  DELETE_MEDIA_GALLERY_ITEM_SUCCESS,
  GET_MEDIA_GALLERY,
  GET_MEDIA_GALLERY_DESIGN,
  GET_MEDIA_GALLERY_DESIGN_FAILED,
  GET_MEDIA_GALLERY_DESIGN_SUCCESS,
  GET_MEDIA_GALLERY_FAILED,
  GET_MEDIA_GALLERY_SUCCESS,
  GET_MEDIA_GALLERY_USERS,
  GET_MEDIA_GALLERY_USERS_FAILED,
  GET_MEDIA_GALLERY_USERS_SUCCESS,
  GET_LANDING_GALLERY,
  GET_LANDING_GALLERY_FAILED,
  GET_LANDING_GALLERY_SUCCESS,
  RESET_MEDIA_GALLERY,
  UPDATE_MEDIA_GALLERY_DESIGN,
  UPDATE_MEDIA_GALLERY_DESIGN_FAILED,
  UPDATE_MEDIA_GALLERY_DESIGN_SUCCESS,
  GET_MEDIA_GALLERY_LIST,
  GET_MEDIA_GALLERY_LIST_SUCCESS,
  GET_MEDIA_GALLERY_LIST_FAILED,
  RESET_MEDIA_GALLERY_LIST,
  UPLOAD_EVENT_MEDIA,
  UPLOAD_EVENT_MEDIA_SUCCESS,
  UPLOAD_EVENT_MEDIA_FAILED,
  UPLOAD_LANDING_MEDIA,
  UPLOAD_LANDING_MEDIA_SUCCESS,
  UPLOAD_LANDING_MEDIA_FAILED,
  DELETE_LANDING_MEDIA,
  DELETE_LANDING_MEDIA_SUCCESS,
  DELETE_LANDING_MEDIA_FAILED,
  UPDATE_MEDIA_CAPTION,
  UPDATE_MEDIA_CAPTION_SUCCESS,
  UPDATE_MEDIA_CAPTION_FAILED,
  RESET_FLAGGED_MEDIA,
  GET_FLAGGED_MEDIA_SUCCESS,
  GET_FLAGGED_MEDIA_FAILED,
  GET_FLAGGED_MEDIA,
  DELETE_MEDIA_REPORT,
  DELETE_MEDIA_REPORT_SUCCESS,
  DELETE_MEDIA_REPORT_FAILED,
} from "./actionTypes"

export const getMediaGallery = params => ({
  type: GET_MEDIA_GALLERY,
  payload: params,
})

export const getMediaGallerySuccess = response => ({
  type: GET_MEDIA_GALLERY_SUCCESS,
  payload: response,
})

export const getMediaGalleryFailed = error => ({
  type: GET_MEDIA_GALLERY_FAILED,
  payload: error,
})

export const getMediaGalleryUsers = params => ({
  type: GET_MEDIA_GALLERY_USERS,
  payload: params,
})

export const getMediaGalleryUsersSuccess = response => ({
  type: GET_MEDIA_GALLERY_USERS_SUCCESS,
  payload: response,
})

export const getMediaGalleryUsersFailed = error => ({
  type: GET_MEDIA_GALLERY_USERS_FAILED,
  payload: error,
})

export const getMediaGalleryDesign = params => ({
  type: GET_MEDIA_GALLERY_DESIGN,
  payload: params,
})

export const getMediaGalleryDesignSuccess = response => ({
  type: GET_MEDIA_GALLERY_DESIGN_SUCCESS,
  payload: response,
})

export const getMediaGalleryDesignFailed = error => ({
  type: GET_MEDIA_GALLERY_DESIGN_FAILED,
  payload: error,
})

export const updateMediaGalleryDesign = params => ({
  type: UPDATE_MEDIA_GALLERY_DESIGN,
  payload: params,
})

export const updateMediaGalleryDesignSuccess = response => ({
  type: UPDATE_MEDIA_GALLERY_DESIGN_SUCCESS,
  payload: response,
})

export const updateMediaGalleryDesignFailed = error => ({
  type: UPDATE_MEDIA_GALLERY_DESIGN_FAILED,
  payload: error,
})

export const deleteMediaGalleryItem = params => ({
  type: DELETE_MEDIA_GALLERY_ITEM,
  payload: params,
})

export const deleteMediaGalleryItemSuccess = response => ({
  type: DELETE_MEDIA_GALLERY_ITEM_SUCCESS,
  payload: response,
})

export const deleteMediaGalleryItemFailed = error => ({
  type: DELETE_MEDIA_GALLERY_ITEM_FAILED,
  payload: error,
})

export const resetMediaGallery = () => ({
  type: RESET_MEDIA_GALLERY,
  payload: {},
})

export const getLandingGallery = params => ({
  type: GET_LANDING_GALLERY,
  payload: params,
})

export const getLandingGallerySuccess = response => ({
  type: GET_LANDING_GALLERY_SUCCESS,
  payload: response,
})

export const getLandingGalleryFailed = error => ({
  type: GET_LANDING_GALLERY_FAILED,
  payload: error,
})

export const getMediaGalleryList = params => ({
  type: GET_MEDIA_GALLERY_LIST,
  payload: params,
})

export const getMediaGalleryListSuccess = response => ({
  type: GET_MEDIA_GALLERY_LIST_SUCCESS,
  payload: response,
})

export const getMediaGalleryListFailed = error => ({
  type: GET_MEDIA_GALLERY_LIST_FAILED,
  payload: error,
})

export const resetMediaGalleryList = () => ({
  type: RESET_MEDIA_GALLERY_LIST,
  payload: {},
})

export const uploadEventMedia = params => ({
  type: UPLOAD_EVENT_MEDIA,
  payload: params,
})

export const uploadEventMediaSuccess = response => ({
  type: UPLOAD_EVENT_MEDIA_SUCCESS,
  payload: response,
})

export const uploadEventMediaFailed = error => ({
  type: UPLOAD_EVENT_MEDIA_FAILED,
  payload: error,
})

export const uploadLandingMedia = params => ({
  type: UPLOAD_LANDING_MEDIA,
  payload: params,
})

export const uploadLandingMediaSuccess = response => ({
  type: UPLOAD_LANDING_MEDIA_SUCCESS,
  payload: response,
})

export const uploadLandingMediaFailed = error => ({
  type: UPLOAD_LANDING_MEDIA_FAILED,
  payload: error,
})

export const deleteLandingMedia = params => ({
  type: DELETE_LANDING_MEDIA,
  payload: params,
})

export const deleteLandingMediaSuccess = response => ({
  type: DELETE_LANDING_MEDIA_SUCCESS,
  payload: response,
})

export const deleteLandingMediaFailed = error => ({
  type: DELETE_LANDING_MEDIA_FAILED,
  payload: error,
})

export const updateMediaCaption = params => ({
  type: UPDATE_MEDIA_CAPTION,
  payload: params,
})

export const updateMediaCaptionSuccess = response => ({
  type: UPDATE_MEDIA_CAPTION_SUCCESS,
  payload: response,
})

export const updateMediaCaptionFailed = error => ({
  type: UPDATE_MEDIA_CAPTION_FAILED,
  payload: error,
})

export const getFlaggedMedia = params => ({
  type: GET_FLAGGED_MEDIA,
  payload: params,
})

export const getFlaggedMediaSuccess = response => ({
  type: GET_FLAGGED_MEDIA_SUCCESS,
  payload: response,
})

export const getFlaggedMediaFailed = error => ({
  type: GET_FLAGGED_MEDIA_FAILED,
  payload: error,
})

export const resetFlaggedMedia = () => ({
  type: RESET_FLAGGED_MEDIA,
  payload: {},
})

export const deleteMediaReport = params => ({
  type: DELETE_MEDIA_REPORT,
  payload: params,
})

export const deleteMediaReportSuccess = response => ({
  type: DELETE_MEDIA_REPORT_SUCCESS,
  payload: response,
})

export const deleteMediaReportFailed = error => ({
  type: DELETE_MEDIA_REPORT_FAILED,
  payload: error,
})
